<template>
  <section>
    <div
      ref="campsiteCancellationPolicy"
      class="prerendered"
      v-html="cancellationPolicy"
    />
    <lazy-google-translate-button
      v-if="needsTranslation"
      :parent="campsiteCancellationPolicyRef"
    />
    <translate tag="p" class="cancellation-footnote">
      Please note that your deposit is paid to Pitchup.com and is
      non-refundable.
    </translate>
  </section>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import VueHooksInfoMixin from '~/mixins/VueHooksInfoMixin'

@Component({
  mixins: [VueHooksInfoMixin],
})
class BookingCancellationPolicy extends Vue {
  @Prop()
  campsiteName: string

  @Prop()
  cancellationPolicy: string

  @Prop({ default: false })
  needsTranslation: boolean

  get campsiteCancellationPolicyRef() {
    // refs are not reactive, so need this little trick to make sure it's there when needed
    if (!this.isMounted) {
      return undefined
    }
    return this.$refs.campsiteCancellationPolicy as Element
  }
}

export default toNative(BookingCancellationPolicy)
</script>

<style scoped>
.cancellation-footnote {
  margin-top: 1em;
  font-size: var(--body);
}

.prerendered :deep(p) {
  font-size: var(--body);
  margin-bottom: 1em;
}
</style>
